export default __webpack_public_path__ + "static/media/silo.d3eb18e3.svg";